import backofficeService from '../../api/backoffice'

export default {
  /**
   * Get list of products
   * @param {*} params
   * @param {*} params.limit
   * @param {*} params.offset
   * @param {*} params.search
   * @param {*} params.local Add LocalData to products
   */
  getAll(params) {
    return backofficeService.Api().get('classRoom', { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  /**
   * Get specific product
   * @param {*} id
   * @param {*} params
   * @param {*} params.local Add LocalData to product
   */
  getById(id, params = {}) {
    return backofficeService.Api().get(`classRoom/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  getClassInfo(params = {}) {
    return backofficeService.Api().get(`classRoom/info`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  /**
   * Create a product. Will also initiate location data
   * @param {*} data
   */
  create(data) {
    return backofficeService.Api().post('classRoom', data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  /**
   * Update specific product
   * @param {*} id
   * @param {*} data
   */
  update(id, data) {
    return backofficeService.Api().put(`classRoom/${id}`, data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  /**
   * Update specific product
   * @param {*} id
   * @param {*} data
   */
  updateClassStudent(id, data) {
    return backofficeService.Api().put(`classRoomStudent/${id}`, data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  setCurriculums(ClassRoomId, data) {
    return backofficeService.Api().post(`/classRoom/${ClassRoomId}/curriculums`, data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  /**
   * Create a product. Will also initiate location data
   * @param {*} data
   */
  assignStudent(data) {
    return backofficeService.Api().post(`classRoomStudent`, data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  getAssignTeacherList(params) {
    return backofficeService.Api().get(`classRoomTeacher`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  getAssignStudentList(params) {
    return backofficeService.Api().get(`classRoomStudent`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  assignTeacher(data) {
    return backofficeService.Api().post(`classRoomTeacher`, data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  removeStudent(id, params) {
    return backofficeService.Api().delete(`classRoomStudent/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  removeTeacher(id, params) {
    return backofficeService.Api().delete(`classRoomTeacher/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  /**
   * Delete product
   * @param {} id
   * @param {*} params
   */
  delete(id, params) {
    return backofficeService.Api().delete(`classRoom/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  generateClassroomReportCard(data) {
    return backofficeService.Api().post(`classRoom/report-card/generate`, data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  getSavedStudentReport(params) {
    return backofficeService.Api().get(`classRoom/report-card/student`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  getLatestReportCardBatch(params) {
    return backofficeService.Api().get(`classRoom/report-card/batch`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  finalizeReportCardBatch(id, data = {}) {
    return backofficeService.Api().put(`classRoom/report-card/finalize/${id}`, data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
}